<p-drawer [visible]="fileUploaderService.visible()" [closable]="true"
          (visibleChange)="fileUploaderService.visible.set($event)" position="right"
          [modal]="true" [blockScroll]="true" [style]="{ width: '95%' }" (onShow)="init()" (onHide)="clear()">
  <ng-template #header>
    <div class="header">
      {{ 'app.file.drawer.header'|translate:{tenant:bootstrap.settings()['tenant']['displayName']} }}
    </div>
  </ng-template>
  <ng-template #content>
    <ems-file-search></ems-file-search>

  </ng-template>
</p-drawer>
